import React from "react";
import styles from "./BeveragesDialog.module.css"

import coffeeSrc from "../../assets/beverageV5/Coffee.svg";
import juicesSrc from "../../assets/beverageV5/Juiice.svg";
import waterSrc from "../../assets/beverageV5/Water.svg";

import { createPortal } from "react-dom";
import clsx from "clsx";

export const BeveragesSuccessDialog = (props) => {
  const { onClose, isRedirecting } = props;

  const handleOverlayClick = (e) => {
    if (e.target.className === styles.overlay) {
      onClose();
    }
  };

  return createPortal(
    <div className={styles.overlay} data-testid="beverage-success-dialog-overlay" onClick={handleOverlayClick}>
      <div className={clsx(styles.dialog, styles.successDialog)} data-testid="beverage-success-dialog" role="dialog" aria-modal="true">
        <button
          data-testid="dialog-close"
          className={`${styles.closeButton} custom_click_track`}
          data-custom_click_track_value="Beverages|Close Success Modal|internal"
          onClick={onClose}
          aria-label="Close beverage confirmation"
        >
          ✕
        </button>

        <div className={styles.images}>
          <img src={coffeeSrc} alt="Coffee" />
          <img src={juicesSrc} alt="Juice" />
          <img src={waterSrc} alt="Water" />
        </div>

        <h2>Thanks!</h2>
        {isRedirecting ? (
          <p>
            Redirecting to{" "}
            <a
              href="https://www.marriott.com/default.mi"
              className="custom_click_track"
              data-custom_click_track_value="Beverages|Marriott.com Redirect Link|external"
            >
              Marriott.com
            </a>...
          </p>
        ) : (
          <p>We&apos;ll take it from here.</p>
        )}
      </div>
    </div>,
    document.body,
  );
}
